import React from "react";
import { Option, none } from "fp-ts/es6/Option";
import { ACRActionType } from "datamodel/permissions";
const context = React.createContext<Option<ACRActionType[]>>(none);

export const { Provider: AccessControlContextProvider, Consumer: AccessControlContextConsumer } =
  context;

export default context;
